import { render, staticRenderFns } from "./PatientImagesList.vue?vue&type=template&id=243625fb&scoped=true&"
import script from "./PatientImagesList.vue?vue&type=script&lang=js&"
export * from "./PatientImagesList.vue?vue&type=script&lang=js&"
import style0 from "./PatientImagesList.vue?vue&type=style&index=0&id=243625fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243625fb",
  null
  
)

export default component.exports